export const RBTitle = {
  partA: `Scheduled orders with`,
  partB: "caleb & brown",
} as const;
